import React, { useState } from "react";

import { apiCall } from '@app/utils/apiCall';
import { useAuth } from '@app/contexts/AuthContext';

import { BookUser, Building2 } from "lucide-react";

import SelectList from "@app/components/2_widgets/SelectList";
import { useNavigate } from "react-router-dom";

export default function SectionSelectCustomer() {
    const [loaded, setLoaded] = useState(false);
    const [customers, setCustomers] = useState([]);

    const auth = useAuth();
    const navigate = useNavigate();
   
    if (!loaded) {
        getCustomers();
    }

    function getCustomers() {
        apiCall({
            method: "get",
            path: `/api/v1/customers`,
            auth: auth,
            onSuccess: (response) => {
                setLoaded(true);
                setCustomers(response.data.customers);
            }
        });        
    }

    function buildOptions() {
        return customers.map((customer) => {
            let companyName = `${customer.company_name} (${customer.siren})`;
            return {value: customer.id, label: companyName, icon: <Building2 size={12} />}
        })
    }

    function onChange(option) {
        navigate(`/customers/${option.value}`);
    }

    return (
        <div>
            <div className="section-title">
                <h3 className="title"><BookUser /> Ou sélectionner une entreprise enregistrée</h3>
                <div className="row">
                    <div className="col-10">
                        <SelectList
                            options={buildOptions()}
                            placeholder="Choisir une entreprise"
                            callbackOnChange={onChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}